import './index_web.css';
import React, { useState } from 'react';
import FixturesMatchList from '../fixtures_match_list';
import LiveMatchList from '../live_match_list';
import ResultMatchList from '../result_match_list';
import { MatchTabBar } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import { View } from '../../../component';
import './index_mWeb.css';

const MatchTabMWeb = ({ fixtureList, liveList, resultList }: any) => {
  const [activeTab, setActiveTab] = useState(0);
  const [routes] = useState([
    { key: 'Fixtures', title: 'Fixtures' },
    { key: 'Live', title: 'Live' },
    { key: 'Results', title: 'Results' }
  ]);
  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };
  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  return (
    <View className="match-tab-wrapper_mWeb flat-list-outer-grow">
      <MatchTabBar activeTab={activeTab} onChangeTab={onChangeTab} routes={routes} />
      <div className="flat-list-outer-grow">
        <SwipeableViews
          className="swipeable-view-outer-container"
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <View className={'match-tab-content_mWeb'}>
            {activeTab === 0 && <FixturesMatchList list={fixtureList} />}
          </View>
          <View className={'match-tab-content_mWeb'}>
            {activeTab === 1 && <LiveMatchList list={liveList} />}
          </View>
          <View className={'match-tab-content_mWeb'}>
            {activeTab === 2 && <ResultMatchList list={resultList} />}
          </View>
        </SwipeableViews>
      </div>
    </View>
  );
};

export default MatchTabMWeb;
